import React from "react";
import HotelGroupDropdown from "./Dropdown/HotelGroupDropdown";
import MarketDropdown from "./Dropdown/MarketDropdown";
import {Box} from "@mui/material";

const HotelGroupMarketSelector = ({
    data,
    setSelectedCategory,
    selectedItem,
    setSelectedItem,
    selectedMarkets,
    setSelectedMarkets,
    selectedType,
    setSelectedType,
    setPage,
}) => {
    return (
        <Box sx={{ display: "flex", justifyContent: "flex-start", mb: 2}}>
            <HotelGroupDropdown
                data={data}
                selectedItem={selectedItem}
                setSelectedItem={setSelectedItem}
                selectedType={selectedType}
                setSelectedType={setSelectedType}
                setSelectedCategory={setSelectedCategory}
                setPage={setPage}
            />

            {/* Markets Filter Section */}
            <MarketDropdown
                data={data}
                selectedMarkets={selectedMarkets}
                setSelectedMarkets={setSelectedMarkets}
                setPage={setPage}
            />
        </Box>
    );
};

export default HotelGroupMarketSelector;
